import HeadingContainer from './HeadingContainer'

export default HeadingContainer;